/* eslint-disable global-require */
const axios = require('axios')

module.exports.getAttending = async (acessToken, uuid, status, data) => {
  const attendentsList = await axios.get(`https://app.manyconvert.com/api/attendings/subattending/${uuid}/${status}?period=${data}`, {
    headers: {
      Authorization: `Bearer ${acessToken}`,
    },
  }).then(resp => resp.data)
  return attendentsList
}

module.exports.getAttendingStores = async acessToken => {
  const attendentsList = await axios.get('https://app.manyconvert.com/api/stores/attending', {
    headers: {
      Authorization: `Bearer ${acessToken}`,
    },
  }).then(resp => resp.data)
  return attendentsList
}

module.exports.getAttendingStatuses = async (acessToken, uuid) => {
  const attendentsList = await axios.get(`https://app.manyconvert.com/api/userstore/store-uuid/${uuid}`, {
    headers: {
      Authorization: `Bearer ${acessToken}`,
    },
  }).then(resp => resp.data)
  return attendentsList
}

module.exports.searchTransactions = async (acessToken, uuid, page, search) => {
  const transactions = await axios.get(`https://app.manyconvert.com/api/attendings/subattendings/history/${uuid}?page=${page}&prevRequest&search=${search}`, {
    headers: {
      Authorization: `Bearer ${acessToken}`,
    },
  }).then(resp => resp.data)
  return transactions
}

module.exports.contacted = async (acessToken, subattending) => {
  const axios = require('axios')

  const config = {
    method: 'post',
    maxBodyLength: Infinity,
    url: `https://app.manyconvert.com/api/attendings/subattending/${subattending}/contacted`,
    headers: {
      Authorization: `Bearer ${acessToken}`,
    },
  }

  return axios.request(config)
    .then(response => response)
    .catch(error => {
      console.log(error)
    })
}

module.exports.getMessage = async (acessToken, transaction, status) => {
  const message = await axios.get(`https://app.manyconvert.com/api/messages/transaction/${transaction}/${status}`, {
    headers: {
      Authorization: `Bearer ${acessToken}`,
    },
  }).then(resp => resp.data)
  return message
}

module.exports.createScheduling = async (acessToken, subattending_id, observations, schedule_date) => {
  const data = {
    observations,
    schedule_date,
    subattending_id,
  }
  const message = await axios.post(`https://app.manyconvert.com/api/attendings/subattending/${subattending_id}/schedule`,
    data,
    {
      headers: {
        Authorization: `Bearer ${acessToken}`,
      },
    }).then(resp => resp.data)

  return message
}
